import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetAllCategoryQuery } from 'App/services/categoryServiceApi';
import { useCreateSubCategoryMutation } from 'App/services/subCategoryServiceApi';
import { Select } from '@mui/material';
import { toast } from 'react-toastify';


export default function SubCategoryFormDialogue() {
  const location = useLocation();
  const data = location.state || {};
  const [open, setOpen] = React.useState(false);
  const [subcategoryName, setSubcategoryName] = React.useState('');
  const [categoryId, setCategoryId] = React.useState(data.data);
  const navigate = useNavigate();


  // console.log("sub ==> ", data)
  const { data: subcategories, error: subcategoriesError, isLoading: subcategoriesLoading } = useGetAllCategoryQuery();
  const [createSubCategory, { isLoading, isError, error }] = useCreateSubCategoryMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddSubCategory = async (event) => {
    event.preventDefault();



    try {
      if (subcategoryName) {
        await createSubCategory({ name: subcategoryName, categoryId });
        toast.success("Sub Category Successfully Created!");
        handleClose();
      }
      else {
        toast.error("subCategory all Field required");
      }
      setSubcategoryName('')
    } catch (error) {

      toast.error(error?.data?.error)
    }
  }




return (
  <React.Fragment>
    <Button variant="contained" color="light" onClick={handleClickOpen}>
      Add Sub Category
    </Button>
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit: handleAddSubCategory,
      }}
    >
      <DialogTitle>Add Sub Category</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the name and select the category for the subcategory:
        </DialogContentText>
        <TextField
          autoFocus
          // required
          margin="dense"
          id="name"
          name="name"
          label="Sub Category Name"
          type="text"

          fullWidth
          value={subcategoryName}
          onChange={(e) => setSubcategoryName(e.target.value)}
          error={!!error}
        />

        <Select
          required
          labelId="category-label"
          label="Category Name"
          fullWidth
          value={categoryId}
          sx={{ height: 40 }}
          onChange={(e) => setCategoryId(e.target.value)}
          displayEmpty
          disabled
        >
          <MenuItem value="" disabled>Select Category</MenuItem>
          {subcategoriesLoading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : subcategoriesError ? (
            <MenuItem disabled>Error loading categories</MenuItem>
          ) : (
            subcategories.map((subcategory) => (
              <MenuItem key={subcategory.id} value={subcategory.id}>
                {subcategory.name}
              </MenuItem>
            ))
          )}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" disabled={isLoading} name="submit">
          Add {isLoading && 'Loading...'}
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
);
}
